
export default {
  smallParcelFreeShippingTier: 300,
  smallParcelShippingCost: 19.95,
  freightFreeShippingTier: 1000,
  freightShippingCost: 89,
  ltlDirectFreeShippingTier: 1000,
  ltlDirectShippingCost: 89
}